<template>
    <b-container class="container-lg">
        <b-row class="pb-2">
            <b-col class="text-start text-truncate">
                <h5>
                    <i class="fa-solid fa-chevron-left" @click="goBack"></i> <i class="text-primary fa-solid fa-info"></i> {{ $t('Contact') }}
                </h5>
            </b-col>
        </b-row>
        <b-card class="rounded-top-0">
            <b-list-group-item class="p-1 border-none border-bottom">
                <div class="d-flex w-100 justify-content-between">
                    <small>
                        {{ $t('Name') }}
                    </small>
                    <small>
                        {{ contact.name }}
                    </small>
                </div>
                <div class="d-flex w-100 justify-content-between">
                    <small>
                        {{ $t('Description') }}
                    </small>
                    <small>
                        {{ contact.description }}
                    </small>
                </div>
                <div class="d-flex w-100 justify-content-between">
                    <small>
                        {{ $t('Email') }}
                    </small>
                    <small>
                        {{ contact.email }}
                    </small>
                </div>
                <div class="d-flex w-100 justify-content-between">
                    <small>
                        {{ $t('Phone') }}
                    </small>
                    <small>
                        {{ contact.phone }}
                    </small>
                </div>
            </b-list-group-item>
            <b-list-group-item class="p-1 border-none border-bottom">
                <div>{{$t('Host notifications')}}</div>
                <b-row>
                    <div>
                        <i v-if="contact.host_notifications_enabled === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.host_notifications_enabled === 0" class="fa-solid fa-square"></i>
                        <small class="ms-1">{{$t('Host notifications enabled')}}</small>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.host_push_notifications_enabled === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.host_push_notifications_enabled === 0" class="fa-solid fa-square"></i>
                        <small class="ms-1">{{$t('Push notifications to browser')}}</small>
                    </div>
                </b-row>
                <b-row>
                    <div>{{$t('Options')}}</div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.notify_host_recovery === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.notify_host_recovery === 0" class="fa-solid fa-square"></i>
                        <b-badge class="ms-1 bg-ok w-50">{{$t('recover')}}</b-badge>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.notify_host_down === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.notify_host_down === 0" class="fa-solid fa-square"></i>
                        <b-badge class="ms-1 bg-down w-50">{{$t('down')}}</b-badge>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.notify_host_unreachable === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.notify_host_unreachable === 0" class="fa-solid fa-square"></i>
                        <b-badge class="ms-1 bg-unreachable w-50">{{$t('unreachable')}}</b-badge>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.notify_host_flapping === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.notify_host_flapping === 0" class="fa-solid fa-square"></i>
                        <div class="ms-1 badge bg-primary-custom w-50">{{$t('flapping')}}</div>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.notify_host_downtime === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.notify_host_downtime === 0" class="fa-solid fa-square"></i>
                        <div class="ms-1 badge bg-primary-custom w-50">{{$t('downtime')}}</div>
                    </div>
                </b-row>
            </b-list-group-item>
            <b-list-group-item class="p-1 border-none">
                <div>{{$t('Service notifications')}}</div>
                <b-row>
                    <div>
                        <i v-if="contact.service_notifications_enabled === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.service_notifications_enabled === 0" class="fa-solid fa-square"></i>
                        <small class="ms-1">{{$t('Service notifications enabled')}}</small>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.service_push_notifications_enabled === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.service_push_notifications_enabled === 0" class="fa-solid fa-square"></i>
                        <small class="ms-1">{{$t('Push notifications to browser')}}</small>
                    </div>
                </b-row>
                <b-row>
                    <div>{{$t('Options')}}</div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.notify_service_recovery === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.notify_service_recovery === 0" class="fa-solid fa-square"></i>
                        <b-badge class="ms-1 bg-ok w-50">{{$t('recover')}}</b-badge>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.notify_service_warning === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.notify_service_warning === 0" class="fa-solid fa-square"></i>
                        <b-badge class="ms-1 bg-warning w-50">{{$t('warning')}}</b-badge>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.notify_service_critical === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.notify_service_critical === 0" class="fa-solid fa-square"></i>
                        <b-badge class="ms-1 bg-critical w-50">{{$t('critical')}}</b-badge>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.notify_service_unknown === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.notify_service_unknown === 0" class="fa-solid fa-square"></i>
                        <b-badge class="ms-1 bg-unknown w-50">{{$t('unknown')}}</b-badge>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.notify_service_flapping === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.notify_service_flapping === 0" class="fa-solid fa-square"></i>
                        <div class="ms-1 badge bg-primary-custom w-50">{{$t('flapping')}}</div>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <i v-if="contact.notify_service_downtime === 1" class="fa-solid fa-square-check"></i>
                        <i v-if="contact.notify_service_downtime === 0" class="fa-solid fa-square"></i>
                        <div class="ms-1 badge bg-primary-custom w-50">{{$t('downtime')}}</div>
                    </div>
                </b-row>
            </b-list-group-item>

        </b-card>

    </b-container>

</template>
<script>
import { BContainer } from 'bootstrap-vue-next';

export default {
    name: "ContactInfo",
    components: {BContainer},
    data() {
        return {
            contact: {},
        }
    },
     mounted() {
        this.contact = this.$store.state.contactInfo;
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        },
    },
    computed: {
       /* contact: function()  {
            return this.$store.state.contactInfo;
        } */
    }
}
</script>



<style scoped>

</style>